"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardHeader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _CardContent = require("./CardContent");

var CardHeader = function CardHeader(props) {
  return /*#__PURE__*/_react["default"].createElement(_CardContent.CardContent, (0, _extends2["default"])({
    header: true
  }, props));
};

exports.CardHeader = CardHeader;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDYXJkSGVhZGVyIiwicHJvcHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9DYXJkL0NhcmRIZWFkZXIudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IENhcmRDb250ZW50IH0gZnJvbSAnLi9DYXJkQ29udGVudCc7XG5cbmludGVyZmFjZSBQcm9wcyBleHRlbmRzIFJlYWN0LkhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50PiB7fVxuXG5leHBvcnQgY29uc3QgQ2FyZEhlYWRlcjogUmVhY3QuRkM8UmVhY3QuUHJvcHNXaXRoQ2hpbGRyZW48UHJvcHM+PiA9IChwcm9wcykgPT4gKFxuICA8Q2FyZENvbnRlbnQgaGVhZGVyIHsuLi5wcm9wc30gLz5cbik7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBSU8sSUFBTUEsVUFBb0QsR0FBRyxTQUF2REEsVUFBdUQsQ0FBQ0MsS0FBRDtFQUFBLG9CQUNsRSxnQ0FBQyx3QkFBRDtJQUFhLE1BQU07RUFBbkIsR0FBd0JBLEtBQXhCLEVBRGtFO0FBQUEsQ0FBN0QifQ==